<template>
  <v-container fluid>
    <v-row justify="center" style="font-size: 20px">
      <b>{{ $t('Create.Invoices') }}</b>
    </v-row>
    <v-row justify="center">
      <v-simple-table :dark="$vuetify.theme.dark" class="table" style="width: 100%">
        <thead>
          <tr>
            <th class="text-center pa-0">
              {{ $t('Invoice Number') }}
            </th>
            <th class="text-center pa-3">
              {{ $t('Amount') }}
            </th>
            <th class="text-center pa-3">
              {{ $t('Outstanding Amount') }}
            </th>
            <th class="text-center pa-0">
              {{ $t('Create.Status') }}
            </th>
            <th class="text-center pa-0" />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in invoices" :key="index" :style="getRowStyle(index)">
            <td class="pa-0">
              {{ item.number }}
            </td>
            <td class="pa-0">
              {{ item.amount }}
            </td>
            <td class="pa-0">
              {{ item.outstandingAmmount }}
            </td>
            <td class="pa-0">
              <span v-if="isStatusPending(item.status)" class="ma-0" style="color: #FF6961">
                {{ $t('InvoiceStatus.Pending') }}
              </span>
              <span v-if="isStatusCreated(item.status)" class="ma-0" style="color: #FF6961">
                {{ $t('InvoiceStatus.Unpayed') }}
              </span>
              <span v-if="isStatusSend(item.payment)" class="ma-0" style="color: green">
                {{ $t('InvoiceStatus.Payed') }}
              </span>
              <span v-if="isStatusPayed(item.payment)" class="ma-0" style="color: #FF6961">
                {{ $t('InvoiceStatus.Charged') }}
              </span>
              <span v-if="isStatusCompensated(item.status)" class="ma-0" style="color: blue">
                {{ $t('InvoiceStatus.Compensated') }}
              </span>
            </td>
            <td style="padding: 10px" @click="goToDetail(item)">
              <v-icon size="18px" style="cursor: pointer; font-weight: normal;margin: 2px">
                fas fa-edit
              </v-icon>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-row>
    <v-btn style="position:absolute; right:0px; bottom: 35px; margin-right: 10px; z-index: 100" color="primary" large fab @click="goUploadInvoice()">
      <v-icon dark x-large>
        mdi-plus
      </v-icon>
    </v-btn>
    <CreateInvoiceModal ref="modal" @refresh="fetch" />
  </v-container>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import moment from 'moment';
import CreateInvoiceModal from "../components/invoice/CreateInvoiceModal";

export default {
    name: "Create",
    components: {CreateInvoiceModal},
    data () {
        return {
            loading: true,
            state: null,
            toPay: true,
            receivable: true,
            invoices: [],
            headers: [
                {
                    text: '',
                    align: 'left',
                    sortable: false,
                    value: 'icons',
                },
                { text: this.$t('Invoice Number'), value: 'number'},
                { text: this.$t('Date'), value: 'date'},
                { text: this.$t('Delay'), value: 'delay'},
                { text: this.$t('Payer'), value: 'payerCif' },
                { text: this.$t('Receiver'), value: 'receiverCif' },
                { text: this.$t('Amount'), value: 'amount'},
                { text: this.$t('Create.Status'), value: 'status' },
                { text: '', value: 'button' },
                { text: '', value: 'delete' },
                { text: '', value: 'modify'},
            ],
            topChangeText: {
                pulling: this.$t('Refreshing') + "...",
                limit: this.$t('Refreshing') + "...",
                loading: this.$t('Refreshing') + "...",
                complete: "  ",
            },
            rowStyle: {
                textAlign: 'center',
                backgroundColor: 'black'
            }
        };

    },
    created () {
        const toPay = localStorage.getItem('toPay');
        if (toPay) {
            this.toPay = toPay === "true";
        }

        const receivable = localStorage.getItem('receivable');
        if (receivable) {
            this.receivable = receivable === "true";
        }
        this.fetch();
    },

    methods: {
        fetch () {
            this.$data.loading = true;
            this.$data.invoices = [];
            ApiRepository.listInvoices(this.receivable, this.toPay, true)
                .then(response => {
                    if (response.data) {
                        const invoices = response.data.invoices;
                        if (invoices) {
                            for (const item of invoices) this.invoices.push(item.invoice);
                            for (let i = 0; i < this.invoices.length; i++) {
                                let date = "";
                                if (this.invoices[i].date === undefined) {
                                    date = new Date();
                                } else {
                                    date = new Date(this.invoices[i].date);
                                }
                                this.invoices[i].date = moment(date).format("DD/MM/YYYY");
                                const today = new Date();
                                const diff_time = today.getTime() - date.getTime();
                                const delay_days = Math.round(parseFloat(diff_time / (1000 * 3600 * 24)));
                                if (delay_days !== null && delay_days < 1) {
                                    this.invoices[i].delay = 0;
                                    this.invoices[i].text = this.$t('Create.days');
                                } else if (delay_days !== null) {
                                    this.invoices[i].delay = delay_days;
                                } else {
                                    this.invoices[i].delay = 0;
                                }
                                if (this.invoices[i].delay > 1) {
                                    this.invoices[i].text = this.$t('Create.days');
                                } else if (this.invoices[i].delay === 1) {
                                    this.invoices[i].text = this.$t('Create.day');
                                }
                            }
                        }
                        this.invoices.sort((a, b) => {
                            return new Date(b.created) - new Date(a.created);
                        });
                    }
                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
                    console.error(err);
                })
                .finally(() => {
                    this.$data.loading = false;
                });
        },
        getRowStyle (index) {
            let p;
            let backgroundColor;
            let alternativeBackgroundColor;
            if (this.$vuetify.theme.dark) {
                backgroundColor = this.$vuetify.theme.themes.dark.background;
                alternativeBackgroundColor = this.$vuetify.theme.themes.dark.alternativeBackground;
            } else {
                backgroundColor = this.$vuetify.theme.themes.light.background;
                alternativeBackgroundColor = this.$vuetify.theme.themes.light.alternativeBackground;
            }
            if (index % 2 === 0) {
                p = {
                    textAlign: 'center',
                    backgroundColor: alternativeBackgroundColor
                };
            } else {
                p = {
                    textAlign: 'center',
                    backgroundColor: backgroundColor
                };
            }
            return p;
        },
        changeResult () {
            localStorage.setItem('toPay', this.toPay);
            localStorage.setItem('receivable', this.receivable);
            this.fetch();
        },
        imAPayer (item) {
            return this.$user.cif === item.payerCif;
        },
        itsMeReceiver (item) {
            return this.$user.cif === item.receiverCif;
        },
        isIllegallyDelayed (item) {
            return item.delay >= 60;
        },
        hideInvoice (item) {
            ApiRepository.hideInvoice(item._id)
                .then(response => {
                    if (response.data) {
                        this.$root.$emit('show-snackbar', {message: this.$t('Create.Invoice deleted successfully!')});
                        this.fetch();
                    }
                })
                .catch(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Create.Error deleting the invoice'), color: "error"});
                })
                .finally(() => {
                    console.log("END");
                });
        },
        payInvoice (item) {
            ApiRepository.invoicePayed(item._id)
                .then(response => {
                    if (response.data) {
                        this.$root.$emit('show-snackbar', {message: this.$t('Invoice payed successfully!')});
                        this.fetch();
                    }
                })
                .catch(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error paying invoice'), color: "error"});
                })
                .finally(() => {
                    console.log("END");
                });
        },
        handleTop () {
            setTimeout(() => {
                this.fetch();
                this.$refs.vueLoad.onTopLoaded(0);
            }, 1000);
        },
        acceptPayment (item) {
            ApiRepository.invoiceAcceptPayment(item._id)
                .then(response => {
                    if (response.data) {
                        this.$root.$emit('show-snackbar', {message: this.$t('Invoice payed successfully!')});
                        this.fetch();
                    }
                })
                .catch(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error paying invoice'), color: "error"});
                })
                .finally(() => {
                    console.log("END");
                });
        },
        isStatusSend (statusItem) {
            return statusItem === Constants.INVOICE.PAYMENT_SENT;
        },
        isStatusPayed (statusItem) {
            return statusItem === Constants.INVOICE.PAYMENT_RECEIVED;
        },
        isStatusCompensated (statusItem) {
            return statusItem === Constants.INVOICE.STATUS_COMPENSATED;
        },
        isStatusCreated (statusItem) {
            return statusItem === Constants.INVOICE.STATUS_CREATED;
        },
        isStatusPending (statusItem) {
            return statusItem === Constants.INVOICE.STATUS_PENDING;
        },
        goToDetail (item) {
            this.$router.push({name: 'invoice', params: {id: item._id}, replace: true});
        },
        newInvoice () {
            this.$refs.modal.show(null);
            this.$refs.modal.reset();
        },
        goUploadInvoice () {
            this.$router.push({name: 'imageInvoice', replace: true});
        },
        onAccept (item) {
            this.$root.$emit('show-confirmation-modal', {
                title: this.$t('Confirmation'),
                message: this.$t('Do you want to delete this invoice?'),
                yes: () => {
                    this.hideInvoice(item);
                },
            });
        },
    },
    sockets: {
        REFRESH_INVOICES () {
            this.fetch();
        }
    },
};
</script>

<style scoped>
  .table{
    background-color: var(--v-background-base);
  }
</style>
